export default "__VITE_ASSET__ByvYYJTo__"